export default __webpack_public_path__ + "static/media/course-1.10447c03.png";